



























import {Vue, Component, Prop} from 'vue-property-decorator'
import FilterPreviousRoundOrbit from '@/components/filters/FilterPreviousRoundOrbit.vue'

@Component({
  components: {
    FilterPreviousRoundOrbit,
  },
})
export default class FilterMyWalletOrbit extends Vue {
  @Prop({type: Number, required: true}) lastRound!: number
  @Prop({type: Number, default: 0}) activeRound!: number

  get maxRound() {
    return Math.max(this.lastRound || 0, this.activeRound || 0)
  }

  onFilter(roundId: number) {
    this.$emit('filter', roundId)
  }
}
